export default "__VITE_ASSET__C3Y_YjqJ__"